import globalStore from 'init/global-store'
import { hostsConfig } from 'init/config'
import submissionMediatorLoader from 'widgets/submission/submission-loader'
import submissionStore, { Source } from 'store/submission-store'
import { ssoCreateReview, ssoGetLoggedInDataForReview } from 'services/sso-service'
import globalConfig from 'init/global.config'

export function writeReview() {
  if (globalConfig.ssoEnabled) {
    if (globalConfig.isPurchaseReq()) {
      ssoCreateReview(globalStore.sku, Source.INLINE)
    } else {
      ssoGetLoggedInDataForReview(globalStore.sku, Source.INLINE)
    }
  } else {
    submissionStore.startRevFlow(
      globalStore.sku,
      hostsConfig.siteKey,
      { page: 'review-form', props: {} },
      { startAction: 'review', source: Source.INLINE },
      document.activeElement as HTMLElement
    )
    submissionMediatorLoader.load()
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/reviews-list/reviews-list-commands.ts